<template>
  <div>
    <span class="status-pill small" :class="{'red' : !params.value, 'green' : params.value}"></span>
    <span>{{params.value ? "Active" : "Inactive"}}</span>
  </div>
</template>

<script>
export default {};
</script>